
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {store} from './redux/store'
import { Provider } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";
// import { IPFSProvider } from "react-ipfs"
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    // <IPFSProvider fallback={<>LOADING</>}>
     <Provider store={store} >
    <App/>
    </Provider>
    // </IPFSProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
